const PlaceHolder = ({ set, direction, justify }) => <div
  className={`flex ${direction === 'col' ? 'flex-col space-y-3' : 'space-x-3'} ${justify || ''}`}
>
  {set.map(({ w, h }) => <div
    style={{ width: w || 10, height: h || 10 }}
    className='bg-secondary rounded-full animate-pulse'
  />)}
</div>;

export const PlaceHold = ({ resolved, children, ...rest }) => resolved ? children : <PlaceHolder {...rest} />;